import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

export const PlanningTeamIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      {/* Rangée équipe (3 points menthe) */}
      <circle cx="8" cy="16" r="1.4" fill="var(--equiply-icon-bg)" />
      <circle cx="12" cy="16" r="1.4" fill="var(--equiply-icon-bg)" />
      <circle cx="16" cy="16" r="1.4" fill="var(--equiply-icon-bg)" />
      {/* Calendrier */}
      <rect
        x="3.5" y="5" width="17" height="15.5" rx="2.5"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5"
      />
      <path
        d="M3.5 10h17"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round"
      />
      <path
        d="M8 3.5v3.5M16 3.5v3.5"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round"
      />
    </svg>
  ),
);
PlanningTeamIcon.displayName = "PlanningTeamIcon";
